@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.dimensions-and-unit {
  display: flex;
  align-items: center;
  color: @dimension-input--dimension-and-unit--text-color;
  min-width: 0;

  .dimensions {
    display: flex;
    align-items: center;
    min-width: 0;
    > * {
      flex: 1;
    }
  }
}
